import { isArray } from "lodash"
import { userPolicyMenu } from "@/config/userGroupPolicy"
import { checkPdpaEnabled } from "./common"
import createStore from '../store';

export const getMenuByPermission = (menu, userPolicy) => {
  if (!isArray(userPolicy)) return menu
  if (isArray(userPolicy) && userPolicy.length <= 0) return menu
  let disAbleMenu: string[] = []

  userPolicy.forEach(item => {
    userPolicyMenu.forEach(list => {
      if (list.featureCode === item.featureCode) {
        if (!item.create) {
          disAbleMenu.push(list.ordertype)
        }
      }
    })
  })
  const modifiedSubmenu = menu.filter((ele) => !disAbleMenu.includes(ele.ordertype));
  return modifiedSubmenu;
}

const getModifiedMenu = (menu, userPolicyMenuList, uniqueChars) => {
  return menu.filter((ele) => {
    if (!userPolicyMenuList.includes(ele.orderType)) return true;
    if (uniqueChars.includes(ele.orderType)) return true
    return false
  });
}
export const getCardMenuByPermission = (menu, userPolicy) => {
  if (!isArray(userPolicy)) return menu
  if (isArray(userPolicy) && userPolicy.length <= 0) return menu
  let disAbleMenu: string[] = []

  userPolicy.forEach(policy => {
    (policy.previlegeList || []).forEach(privilege => {
      (privilege.permissionList).forEach(item => {
        userPolicyMenu.forEach(list => {
          if (list.featureCode === item.featureCode) {
            if (item.create) {
              disAbleMenu.push(list.ordertype)
            }
          }
        })
      })
    })
  })
  let uniqueChars = [...new Set(disAbleMenu)];
  const userPolicyMenuList: any = []
  userPolicyMenu.forEach(item => userPolicyMenuList.push(item.ordertype))
  return getModifiedMenu(menu, userPolicyMenuList, uniqueChars);
}

export const getUserPermission = (featureCode, userPolicy) => {
  const { store } = createStore;
  const authStore = store.getState().auth;
  if (checkPdpaEnabled(authStore)) return true;
  if (!isArray(userPolicy)) return false;
  if (isArray(userPolicy) && userPolicy.length <= 0) return false;
  if (featureCode === undefined || featureCode.length < 1) return true
  let permissionList: any = [];
  userPolicy.forEach(policy => {
    (policy.previlegeList || []).forEach(privilege => {
      const data = privilege.permissionList.filter((data) => data.featureCode === featureCode)
      if (data.length > 0) permissionList.push(data[0])
    })
  })
  if (permissionList.length > 0) {
    return permissionList.reduce(
      (accumulator, currentValue) => accumulator || currentValue['create'] || currentValue['read'],
      false
    )
  }
  return false
}

export const getSERUserPermission = (userPolicy) => {
  if (!isArray(userPolicy)) return false;
  if (isArray(userPolicy) && userPolicy.length <= 0) return false;
  return userPolicy.some((ele) => ele.roleName === 'SER')
}